/* 🤖 this file was generated by svg-to-ts */
export const DfIconFacebookSquare16: {
  name: 'facebook-square-16';
  data: string;
} = {
  name: 'facebook-square-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM9.164 4c-1.145 0-1.892.693-1.892 1.949v1.103H6V8.5h1.272V12h1.565V8.5h1.167l.222-1.448h-1.39v-.94c0-.395.195-.782.817-.782h.632V4.098S9.712 4 9.164 4z"/></svg>`
};
